import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import MonthCalendar from './monthCalendar';
import MonthAppointmentRow from './MonthAppointmentRow';
import { ErrorMessage } from '../common';
import { ERROR_MESSAGE_SCREEN } from '../../constants';
import { APPOINTMENT_STATUS } from '_constants';
import NoAppntIcon from 'assets/images/NoAppntIcon.svg';

const MonthView = ({ ...props }) => {
  const { appointmentList, currentDate, fetchMonthAppointments, changeMonthActiveDate, activeDate } = props;
  let appts = [];
  if (appointmentList) {
    appts = appointmentList.sort((a, b) => moment(a.startDate) - moment(b.startDate)).filter(appointment => appointment.eventStatus.id !== APPOINTMENT_STATUS.TENTATIVE.id);
  }
  if (currentDate) {
    appts = appts.filter(a => {
      return moment(a.startDate).format('YYYY/MM/DD') === moment(currentDate).format('YYYY/MM/DD');
    });
  }

  return (
    <div className='month-view-container'>
      <div className='calendar-container'>
        <MonthCalendar
          currentDate={currentDate}
          appointmentList={appointmentList.filter(appointment => appointment.eventStatus.id !== APPOINTMENT_STATUS.TENTATIVE.id)}
          fetchMonthAppointments={fetchMonthAppointments}
          changeMonthActiveDate={changeMonthActiveDate}
          activeDate={activeDate} />
      </div>
      <div className='month-appointments'>
        {
          (appts || []).length === 0 ? <ErrorMessage errorMessage={ERROR_MESSAGE_SCREEN.NO_APPOINTMENTS} errorImage={NoAppntIcon} />
            : (appts || []).map((item, index) => <MonthAppointmentRow key={index} appointment={item} />)
        }
      </div>

    </div >
  );
};

MonthView.propTypes = {
  appointmentList: PropTypes.array.isRequired,
  currentDate: PropTypes.object,
  activeDate: PropTypes.object,
  fetchMonthAppointments: PropTypes.func,
  changeMonthActiveDate: PropTypes.func
};

export default MonthView;
